/**
 * How many grid cells one application of a stored spray pattern touches.
 *
 * The one place the client answers "how wide is this skill". It used to read a
 * stored multi_target flag instead, which could disagree with the pattern the
 * same row carried.
 *
 * Mirrors `cells_in` in `apps/game/services/skills/area.py`.
 */
export function cellsIn(sprayConfig) {
  const pattern = sprayConfig?.spray;
  if (!Array.isArray(pattern)) return 1;
  const touched = pattern
    .flat()
    .filter((cell) => cell === 1 || cell === '1' || cell === 'x').length;
  return Math.max(1, touched);
}

/** Whether a skill's pattern reaches more than the cell it is aimed at. */
export function isAreaPattern(sprayConfig) {
  return cellsIn(sprayConfig) > 1;
}
